// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget-type-list .widget-type-list-item[data-v-f831ac48]{display:inline-block;text-align:center;cursor:pointer;padding:15px;border:1px solid transparent;min-width:90px;margin-bottom:10px}.widget-type-list .widget-type-list-item i[data-v-f831ac48]{font-size:30px}.widget-type-list .widget-type-list-item[data-v-f831ac48]:hover{border:1px solid #ddd}.widget-type-list .widget-type-list-item-active[data-v-f831ac48]{color:#409eff}", ""]);
// Exports
module.exports = exports;
